import { GlobalAxios } from "../axios/axios-config";
import { IListContact } from "../models/list-contact";

const LIST_CONTACTS = process.env.REACT_APP_MAIN + "/api/v1/ListContact/";

export const getListContactById = (id: string) => {
  return GlobalAxios.get<IListContact>(LIST_CONTACTS + id);
};
